import React from 'react'
import { Icon, Tooltip } from '@pandiafi/components'

interface FormFieldInfoTooltipProps {
  text: string
}

export const FormFieldInfoTooltip: React.FC<FormFieldInfoTooltipProps> = ({
  text,
}) => (
  <Tooltip
    containerClassName="ml-1 text-common-gray-6"
    triggerArea={
      <Icon icon="info-circle" size="s" className="relative -top-px" />
    }
  >
    {text}
  </Tooltip>
)
